import { defineMessages } from 'react-intl';

export const i18n: {
	emptyTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyContentInEditor: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	error: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorLabelsRequired: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorParseMax: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorSearch: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorInvalidInput: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	excerptSeparator: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spaceLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	emptyTitle: {
		id: 'content-by-label-macro.emptyTitle',
		defaultMessage: 'Filter by label',
		description: 'Default heading shown in the empty state when no title is provided',
	},
	emptyContent: {
		id: 'content-by-label-macro.emptyContent',
		defaultMessage: 'There are no items with the selected labels at this time.',
		description: 'Message shown when no content matches the configured labels',
	},
	emptyContentInEditor: {
		id: 'content-by-label-macro.emptyContentInEditor',
		defaultMessage:
			'There are no items with the selected labels at this time. Click the edit icon to configure labels.',
		description:
			'Message shown when no content matches the configured labels with hint encouraging users to edit the macro',
	},
	error: {
		id: 'content-by-label-macro.error',
		defaultMessage: 'An error occurred while loading content by label.',
		description: 'Generic error message for the content by label macro',
	},
	loading: {
		id: 'content-by-label-macro.loading',
		defaultMessage: 'Retrieving content…',
		description: 'Message indicating the content-by-label macro is fetching results',
	},
	errorLabelsRequired: {
		id: 'content-by-label-macro.errorLabelsRequired',
		defaultMessage: "'labels' parameter is required.",
		description: 'Error message when the labels parameter is missing',
	},
	errorParseMax: {
		id: 'content-by-label-macro.errorParseMax',
		defaultMessage: "Error parsing 'maxResults' parameter.",
		description: 'Error message when the max results parameter cannot be parsed',
	},
	errorSearch: {
		id: 'content-by-label-macro.errorSearch',
		defaultMessage: 'Error running search.',
		description: 'Error message when the search request fails',
	},
	errorInvalidInput: {
		id: 'content-by-label-macro.errorInvalidInput',
		defaultMessage: 'Invalid input.',
		description:
			'Error message shown when the content-by-label search request fails because the macro CQL contains unsupported input',
	},
	excerptSeparator: {
		id: 'content-by-label-macro.excerptSeparator',
		defaultMessage: '—',
		description: 'Separator character displayed before excerpt text',
	},
	spaceLabel: {
		id: 'content-by-label-macro.spaceLabel',
		defaultMessage: '({spaceName})',
		description: 'Space name displayed next to content title',
	},
});
